import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import SyncButton from '../forms/SyncButton'
import AutoCompleteSearch from '../common/AutoCompleteSearch'
import BankItem from './banks/BankItem'
import NewBank from './banks/NewBank'
import ConfirmReLogin from './banks/ConfirmReLogin'
import Loading from '../common/Loading'
import Paginate from '../common/Paginate'
import ToastHelper from '../../util/toast-helper'
import NoticeModal from '../common/NoticeModal'
import DropList from '../common/DropList'
import InputSearch from '../common/InputSearch'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import lodash from "lodash"

import {mapDispatchToProps} from "../mapDispatchToProps"
import withBaseComponent from '../withBaseComponent';
import { MAX_BANKS,
         defaultAccountStatusOpts, defaultAccountStatus,
         defaultOrderAccount,
         defaultOrderAccountOpts } from '../../constants'
import { orderBy } from '../../util/list-helper'
import $ from 'jquery'
import { trackingEvent } from "./layouts/GoogleAnalytics.js"

class Bank extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props)

    this.searchAddBank = this.searchAddBank.bind(this)
    this.callBackAfterPageChanged = this.callBackAfterPageChanged.bind(this)
    this.handleAfterCreatedBank = this.handleAfterCreatedBank.bind(this)
    this.handleAfterDeletedBank = this.handleAfterDeletedBank.bind(this)
    this.handleAfterSuspendBank = this.handleAfterSuspendBank.bind(this)
    this.handleAfterResumeSuspendedBank = this.handleAfterResumeSuspendedBank.bind(this)

    this.handleSearchBank = this.handleSearchBank.bind(this)
    this.handleValueSearchChange = this.handleValueSearchChange.bind(this)
    this.handleSelectedSearchItem = this.handleSelectedSearchItem.bind(this)

    this.trackingAddBank = this.trackingAddBank.bind(this);
    this.trackingUpdateAll = this.trackingUpdateAll.bind(this);
    this.trackingStatus = this.trackingStatus.bind(this);
    this.trackingOrder = this.trackingOrder.bind(this);

    this.state = Object.assign({}, this.state, {
      updateAll: false,
      service: null,
      canSubmit: false,
      currentFilterOption: defaultAccountStatus,
      currentOrderOption: defaultOrderAccount,
      filters: defaultAccountStatus.value,
      orders: defaultOrderAccount.value,
      valueSearch: '',
      resultSearchIds: null
    })
  }

  update_all() {
    this.setState({updateAll: true})

    const ids = this.props.accountList.map(account => account.id)
    ToastHelper.success(i18n.t('bank.messages.start_bulk_update'))
    Promise.all([this.aggregate(ids)]).then(() => setTimeout(() => this.setState({updateAll: false}), 5000))
  }

  aggregate(ids) {
    return Promise.all([
      this.props.accountActions.accountAggregate(ids)
    ]).then(() => {
      let account_ids = ids

      if(ids.length > 1)
        account_ids = this.state.currentList.map(item => item.id)

      return Promise.all([
        account_ids.forEach(id => this.props.accountActions.accountShow(id))
      ])
    })
  }

  searchAddBank(item){
    this.setState({loading: true})
    this.props.accountActions.accountTotal().then(() => {
      this.setState({loading: false})
      if (this.props.accountTotal >= MAX_BANKS){
        this.toggleModal('limitBankNotice')
        return
      } else {
        this.addBank(item)
      }
    })
  }

  addBank(item) {
    if(!item)
      return

    Promise.all([
      this.props.serviceActions.getService(item.id)
    ]).then(res => {
      if (this.props.currentService) {
        const {id, omniauth_provider_name, requires_provider_auth} = this.props.currentService
        if (requires_provider_auth) {
          this.props.screenActions.screenLoadingModal(true);
          this.props.accountActions.loginService(omniauth_provider_name, id, this.props.userEmail)
          return;
        }
      }

      this.setState({isFetching: false})
    })

    this.setState({service: item});
    this.toggleModal('newBank');
  }

  render_search_bank() {
    return (
      <div className="row no-gutters">
        <div className="col-sm-9 title padl-0 mfc-search-title">{i18n.t("bank.search_title")}</div>
        <div className="col-sm-3 text-right"></div>
        <div className="col-sm-12 content-body text-left">
          <AutoCompleteSearch placeholder={i18n.t("bank.search_placeholder")} dataList={this.props.serviceList} searchName="name" selected={this.searchAddBank}/>
        </div>
      </div>
    )
  }

  trackingAddBank() {
    trackingEvent("Bank", "新規追加")
    this.toggleModal()
  }

  trackingUpdateAll() {
    trackingEvent("Bank", "データ一括更新")
    this.update_all()
  }

  trackingStatus() {
    trackingEvent("Bank", "フィルタ(状態)")
  }

  trackingOrder() {
    trackingEvent("Bank", "フィルタ(並び順)")
  }

  hasAccounts() {
    return this.props.accountList.length > 0
  }

  render_search_results(){
    return this.state.currentList.length > 0 ?
      this.state.currentList.map(account =>
        <BankItem
          key={account.id}
          item={account}
          aggregate={(ids) => this.aggregate(ids)} syncing={this.state.updateAll}
          onDeleted={this.handleAfterDeletedBank}
          onSuspended={this.handleAfterSuspendBank}
          onResumeSuspended={this.handleAfterResumeSuspendedBank}
        />
      )
      : <label>{i18n.t('bank.messages.have_no_account')}</label>
  }

  renderTutorialStep2() {
    if (!this.hasAccounts() || this.props.applications.length !== 0)
      return null

    return (
      <div className="row no-gutters mfc-tutorial">
        <div className="col-sm-12 content-body text-center tut-block-one" style={{marginBottom: "24px"}}>
          <p className="step-one">{i18n.t('bank.tut_two.title')}</p>
          <p>{i18n.t('bank.tut_two.desc')}</p>
        </div>
      </div>
      )
  }

  renderTutorialStep1() {
    if (this.props.accountList.length > 0)
      return null

    return (
      <div className="row no-gutters mfc-tutorial">
        <div className="col-sm-12 content-body text-center tut-block-one">
          <div className="row">
            <div className="col-sm-12">
              <p className="mfc-big-title">{i18n.t('bank.tut_one_title')}</p>
              <div>{i18n.t('bank.tut_one_desc_1')}<br/>{i18n.t('bank.tut_one_desc_2')}</div>
              <img alt="tutorial" src={require('../../../assets/images/bank/tutorial-image.jpg')} width="60%"/>
              <hr />
              <div className="step-one">{i18n.t('bank.tut_one_step_one')}</div>
              <p>{i18n.t('bank.tut_one_desc_3')}</p>
            </div>
            <div className="col-sm-12 justify-content-md-center mfc-search-bank">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {this.render_search_bank()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleSearchBank(text, callback) {
    const { accountList } = this.props
    const ids = accountList.filter((account) => {
      return account.display_name.includes(text)
    }).map(item => item.id)

    const filters = Object.assign({}, defaultAccountStatus.value, {id: ids})
    this.setState({filters: filters,
      currentFilterOption: defaultAccountStatus,
      orders: defaultOrderAccount.value,
      currentOrderOption: defaultOrderAccount,
      resultSearchIds: ids
    }, () => {
      if(callback)
        callback()
      else
        this.handlePagingChange('accountList', 1)
    })
  }

  setFilters(filter) {
    const filters = filter.value

    if(Array.isArray(filters)){
      filters.forEach((filter) => {
        if(this.state.resultSearchIds)
          filter["id"] = this.state.resultSearchIds
      })
    } else if (this.state.resultSearchIds) {
      filters["id"] = this.state.resultSearchIds
    }

    this.setState({filters: filters, currentFilterOption: filter}, () => this.handlePagingChange('accountList', 1))
  }

  setOrders(order) {
    this.setState({orders: order.value, currentOrderOption: order}, () => this.handlePagingChange('accountList', 1))
  }

  callBackAfterPageChanged(nameList, pageNumber, perPage) {
    this.handlePagingChange(nameList, pageNumber, perPage)
  }

  handleValueSearchChange(value) {
    this.setState({
      valueSearch: value
    })
  }

  handleSelectedSearchItem(item) {
    const callback = () => {
      this.handleLoadSelectedPage(item, true)
      $(':focus').blur()
    }
    this.handleSearchBank('', callback)
  }

  render_bank() {
    let pagingComponent = null;
    if(this.state.currentList.length > 0){
      pagingComponent = <Paginate
                          ref={this.paging}
                          callback={this.callBackAfterPageChanged}
                          totalCount={this.state.totalCount}
                          activePage={this.state.activePage}
                          perPage={this.state.perPage}
                          nameList="accountList" />
    }

    return (
      <div>
        <div className="row no-gutters search-box form-inline">
          <InputSearch
            dataList={this.props.accountList}
            searchName="display_name"
            value={this.state.valueSearch}
            onTextChange={this.handleValueSearchChange}
            placeholder={i18n.t("bank.input_search_placeholder")}
            onSubmit={this.handleSearchBank}
            selected={this.handleSelectedSearchItem}
          />
          <div className="btn-groups">
            <SyncButton syncing={this.state.updateAll} label={i18n.t("bank.update_all")} onClick={() => this.trackingUpdateAll()}/>
            <button className="btn mfc-btn-blue" onClick={() => this.trackingAddBank()}>
              <i className="fas fa-plus"></i>
              <span style={{paddingLeft: "7px"}}>{i18n.t("bank.searchBank")}</span>
            </button>
            <Modal isOpen={this.state.isOpenModal} className={`search-bank-modal`} centered={true}>
              <ModalHeader toggle={this.toggleModal}>{i18n.t("bank.search_title")}</ModalHeader>
              <ModalBody>
                <div className="row middle">
                  {this.state.loading ?
                    <Loading className="fa-3x" /> :
                    <AutoCompleteSearch className="" placeholder={i18n.t("bank.search_placeholder")} dataList={this.props.serviceList} searchName="name" selected={this.searchAddBank}/>}
                </div>
              </ModalBody>
              {!this.state.loading && <ModalFooter>
                <Button onClick={this.toggleModal} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
              </ModalFooter>}
            </Modal>
          </div>
        </div>
        {this.hasAccounts() && <div className="row no-gutters paging-group">
          <div className="filters">
            <label>{i18n.t("bank.filters.status")}：</label>
            <DropList defaultOption={this.state.currentFilterOption}
                      options={defaultAccountStatusOpts}
                      onChanged={(filter) => {this.setFilters(filter); trackingEvent("Bank", "フィルタ(状態)")}}
                      className="droplist-filter"/>
            <label>{i18n.t("bank.filters.orderBy")}：</label>
            <DropList defaultOption={this.state.currentOrderOption}
                      options={defaultOrderAccountOpts}
                      onChanged={(order) => { this.setOrders(order); trackingEvent("Bank", "フィルタ(並び順)")}}
                      className="droplist-filter"/>
          </div>
          { pagingComponent }
        </div>}
        {this.render_search_results()}
        {this.state.currentList.length > 0 && <div className="row no-gutters paging-group">
          <div className="filters"></div >
          { pagingComponent }
        </div>}
      </div>
    )
  }

  componentDidMount() {
    this.props.screenActions.screenLoading(true)
    Promise.all([
      this.props.accountActions.accountList(),
      this.props.userActions.applications(),
      this.props.serviceActions.serviceList(),
      this.props.userActions.tags()
    ]).then(res => {
      const {account_identifier} = this.props.match.params

      // Check in case have account_identifier on url valid or not
      if(account_identifier){
        let valid_account_identifier = false
        const identifiers = account_identifier.split('.')
        let selectedAccount = null

        if(this.props.encryptedUid !== identifiers[0]){
          this.handlePagingChange('accountList')
          this.toggleModal('confirmReLogin')
          return
        }

        this.props.accountList.forEach((account) => {
          if(account.encrypted_id === identifiers[1]){
            valid_account_identifier = true
            selectedAccount = account
          }
        })

        if(valid_account_identifier){
          this.handleLoadSelectedPage(selectedAccount)
        } else {
          this.props.history.push('/bank')
          ToastHelper.error(i18n.t("bank.messages.invalid_account_identifier"))
          this.handlePagingChange('accountList')
        }
      } else { // In normal case: have no account_identifier
        this.handlePagingChange('accountList')
      }
    }).then(() => {
      this.props.serviceActions.serviceList()
      this.props.userActions.tags()
      this.props.screenActions.screenLoading(false)
    })
  }

  componentDidUpdate(prevProps) {
    if (!lodash.isEqual(prevProps.accountList, this.props.accountList)){
      // Update account info to screen
      if(['ACCOUNT_UPDATE', 'ACCOUNT_SHOW', 'SUB_ACCOUNT_UPDATE', 'ACCOUNT_INQURE'].includes(this.props.lastAction.type)){
        this.updateCurrentList()
      }
    }
  }

  updateCurrentList() {
    const newList = [...this.state.currentList]
    for(let i = 0; i < newList.length; i++){
      if(newList[i].id === this.props.lastAction.payload.id ){
        newList[i] = this.props.accountList.find((account) => account.id === newList[i].id )
        break;
      }
    }

    this.setState({
      currentList: newList
    })
  }

  setStep(step=null) {
    this.setState({step: step})
  }

  handleAfterCreatedBank() {
    const { accountList } = this.props
    const orderCreatedAt = defaultOrderAccountOpts.find((item) => item.value.attr === "created_at")

    this.setState({
      filters: defaultAccountStatus.value,
      orders: orderCreatedAt.value,
      currentFilterOption: defaultAccountStatus,
      currentOrderOption: orderCreatedAt,
      valueSearch: ''
    }, () => {
      this.handlePagingChange('accountList', 1)
      this.props.accountActions.accountSelect(accountList[accountList.length - 1].id)
    })
  }

  handleAfterDeletedBank() {
    // Handle after deleted an account
    const filterList = this.filters(this.props.accountList, this.state.filters)
    let page = Math.ceil(filterList.length / this.state.perPage)
    if(this.state.activePage > page){
      page = this.state.activePage - 1
    } else {
      page = this.state.activePage
    }

    this.handlePagingChange('accountList', page)
  }

  handleAfterSuspendBank() {
    this.handlePagingChange('accountList')
  }

  handleAfterResumeSuspendedBank() {
    this.handlePagingChange('accountList')
  }

  handleLoadSelectedPage(account, isHighlightAtOnce) {
    let current_account_index = 0;
    let list = [ ...this.props.accountList ]

    orderBy(list, {attr: 'display_name', direction: 'asc'})
    list.forEach((item, index) => {
      if(account.id === item.id){
        current_account_index = index
        return
      }
    })

    const currentPage = Math.ceil((current_account_index + 1) / this.state.perPage)
    this.handlePagingChange('accountList', currentPage)

    if(isHighlightAtOnce)
      this.props.accountActions.accountSelect(account.id, true, 10)
    else
      this.props.accountActions.accountSelect(account.id, true)
  }

  render() {
    if (this.props.isLoading)
      return <Loading className="fa-7x loading" />;

    return (
      <div className="bank-container small-container" id="bank-container">
        {this.renderTutorialStep1()}

        {this.renderTutorialStep2()}

        {this.hasAccounts() && this.render_bank()}

        {this.state.currentModal === 'newBank' &&
          <NewBank
            isOpen={this.state.currentModal === 'newBank'}
            toggle={this.toggleModal}
            service={this.state.service}
            canSubmit={this.state.canSubmit}
            showErrors={this.showErrors}
            enableButton={this.enableButton}
            disableButton={this.disableButton}
            setStep={(step) => this.setStep(step)}
            onCreated={this.handleAfterCreatedBank} />
        }

        {this.state.currentModal === 'confirmReLogin' &&
          <ConfirmReLogin
            isOpen={this.state.currentModal === 'confirmReLogin'}
            toggle={this.toggleModal}
            email={this.props.userEmail}
            />
        }

        <NoticeModal
           isOpen={this.state.currentModal === 'limitBankNotice'}
           toggle={this.toggleModal}
           title={i18n.t('bank.notice_modal.title')}
           body={i18n.t('bank.notice_modal.msg')}
         />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.screen.get('isLoading'),
    user: state.user,
    accountTotal: state.user.get('accountTotal'),
    accountList: state.user.get('accounts'),
    serviceList: state.service.get('services'),
    currentService: state.service.get('currentService'),
    applications: state.user.get('applications'),
    userEmail: state.user.get('email'),
    encryptedUid: state.user.get('encrypted_uid'),
    lastAction: state.lastAction
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Bank)
